import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/lagan-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function Lagan(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Монтаж инверторных станций ИС-5000 </span><br /> на СЭС Лаганская</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Строительство 11 инверторных станций ИС-5000 для Лаганской СЭС.</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «БНК».</p>
                            <p><strong>Конечный заказчик: </strong>ООО «Юнигрин Инжиниринг».</p>
                            <p><strong>Дата: </strong>сентябрь - октябрь 2025 г.</p>
                            <p><strong>Срок выполнения: </strong>60 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Выполнен полный цикл монтажа 11 инверторных станций (ИС-5000) (мощностью 5 МВт каждая).</li>
                                <li>Построен инверторный парк мощностью 55 МВт для СЭС Лаганская.</li>
                                <li>Обеспечена трансформация и передача электроэнергии от фотоэлектрических панелей в сеть 10 кВ.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Смонтированы основания (рамы) под инверторы, шинопровод и трансформаторы.</li>
                                <li>Применены трансформаторы ТМГ-СЭЩ-2500/10,5/0,6 кВ и установлены инверторы UG-2500-600-PHV (2500 кВт, 600 В).</li>
                                <li>Смонтирован шинопровод в комплекте «инвертор – трансформатор» на каждой станции.</li>
                                <li>Установлены КРП(Н)-10,5-УХЛ1 (БМЗ) с площадками обслуживания.</li>
                                <li>Выполнена прокладка кабельных линий 10 кВ от трансформаторов до ячеек РУ.</li>
                                <li>Смонтирована система заземления ИС-5000, выполнено расключение ЩСН и шкафов связи.</li>
                                <li>Проведены пусконаладочные работы инверторных станций, включая наладку ОПС и шкафов связи, подготовлен технический отчёт ПНР.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}